import React, { Suspense, lazy } from "react";
import SummaryCard from "./SummaryCard";
import PricingCard from "./PricingCard";
import SpecsCard from "./SpecsCard";
import DescriptionCard from "./DescriptionCard";
import BusinessAttributionCard from "./BusinessAttributionCard";
import SellerCard from "../SellerSection/SellerCard";
import QueriesSection from "../SellerSection/QueriesSection";
import { useProductInfo } from "../../hooks/useProductInfo";
import { useSlotCalendarGate } from "../../hooks/useSlotCalendarViewer";

// Lazy: listings whose business has the calendar off (or non-rentals) never
// download its code, and the card never mounts, so no calendar API is called.
const SlotAvailabilityCard = lazy(() => import("../SlotAvailabilitySection/SlotAvailabilityCard"));
import "./styles/ProductInfoSection.css";

const ProductInfoSection: React.FC = () => {
  const { businessId, businessName } = useProductInfo();
  const hasBusiness = Boolean(businessId && businessName);
  const showSlotCalendar = useSlotCalendarGate();

  return (
    <div className="pisecv2">
      <SummaryCard />
      <PricingCard />
      {/* Right after Pricing, before Specs - plan doc §7 Q10 */}
      {showSlotCalendar && (
        <Suspense fallback={null}>
          <SlotAvailabilityCard />
        </Suspense>
      )}
      <SpecsCard />
      <DescriptionCard />
      {hasBusiness ? <BusinessAttributionCard /> : <SellerCard />}
      <QueriesSection />

      {/* {isCurrentUserSeller && (
        <div className="pisecv2__seller-notice">
          <span>👤</span>
          <span>This is your listing</span>
        </div>
      )} */}
    </div>
  );
};

export default ProductInfoSection;
